module.exports = __webpack_public_path__ + "img/banner-01.ba90ae97.jpg";